module.exports = __webpack_public_path__ + "static/img/avatar3.f3bd434.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar3.png
// module id = g+1R
// module chunks = 0